<template>
  <div style="margin:auto; max-width:500px"     class="mx-auto">

          </div>
        <!-- </v-card> -->

</template>

<script>
export default {
  name: "Home",

  data() {
    return {
      
      cards: [
        {
          title: "Pre-fab homes",
          src: "https://cdn.vuetifyjs.com/images/cards/house.jpg",
          flex: 12,
        },
        {
          title: "",
          src:
            "https://firebasestorage.googleapis.com/v0/b/hebelsolar.appspot.com/o/agenda.png?alt=media&token=68434f39-2737-47fc-9873-e1459fd6659f",
          flex: 4,
        },
        {
          title: "Nova proposta",
          src:
            "https://firebasestorage.googleapis.com/v0/b/hebelsolar.appspot.com/o/propostas.png?alt=media&token=230f1349-3564-46bb-b888-17e56fef7394",
          flex: 8,
        },
      ],
    };
  },

  methods: {
    getColor (calories) {
      if (calories > 400) return 'red'
      else if (calories > 200) return 'orange'
      else return 'green'
    },
    test() {
      alert("test");
    },
    complete(index) {
      this.list[index] = !this.list[index];
    },
  },
};
</script>

<style scoped>
.labelValue{
   display: block;
   width: 120px;
   margin: auto;
   text-align:center;
 
}
.cardLabel{
   position:absolute;
    right:10px;
    top:20px;
    height:60px;
     width:240px;
     background-color:#4C6563;
     border-radius: 15px;
}
table {border: none!important;}
</style>
